module.exports = __webpack_public_path__ + "img/widebridge.ba93bba2.jpg";